import { Navigate, createFileRoute, useParams } from '@tanstack/react-router'

import Spinner from '@/components/spinner'

import { useIdentity } from '@/state/identity'

export const Route = createFileRoute('/invite/$invite_token/')({
    component: InviteToken,
})

function InviteToken() {
    const { identity, fetched } = useIdentity()
    const { invite_token } = useParams({
        from: '/invite/$invite_token/',
    })

    if (identity) {
        return (
            <Navigate
                to="/invite/$invite_token/current"
                params={{
                    invite_token,
                }}
            />
        )
    }

    if (!fetched) {
        return <Spinner size="md" absolute />
    }

    return (
        <Navigate
            to="/signup"
            search={{
                invite_token,
            }}
        />
    )
}
